import React, { useEffect } from "react";
import { useThemeMode } from "../../../../context/contextTheme";
import CyberIntel from "../feed";

const CyberIntelBody = () => {
  const { theme } = useThemeMode();
  useEffect(() => {
    return () => {
      document.body.classList.remove("offcanvas-backdrop");
      document.body.style.overflow = "";
      document.body.style.pointerEvents = "";
      const backdrops = document.querySelectorAll(".offcanvas-backdrop, .modal-backdrop");
      backdrops.forEach((backdrop) => backdrop.remove());
    };
  }, []);

  return (
    <div
      className="offcanvas offcanvas-end"
      id="staticBackdropCyberIntel"
      tabIndex={-1}
      aria-labelledby="staticBackdropCyberIntelLabel"
      data-bs-backdrop="static"
      style={{ background: theme.background, color: theme.textColor }}
    >
      <div className="offcanvas-header">
        <div className="offcanvas-title fs-4 fw-semibold ps-2">
          Cyber Intel
        </div>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
      </div>

      <div className="offcanvas-body">
        <CyberIntel />
      </div>
    </div>
  );
};

export default CyberIntelBody;
